import React, { Component } from 'react';
import Login from '../common/login';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as authActions from '../modules/authentication';
import * as orderActions from '../modules/orderdata';
import Main from './main';
import { withRouter } from 'react-router';
import GlobalNotifications from '../common/globalnotifications';
import ChangePassword from '../userprofile/changepassword';
import moment from 'moment';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { ThemeProvider } from '@mui/material/styles';
import theme from './VadoTheme';
import themeMui5 from './VadoThemeMui5';
import CacheBuster from './cachebuster';
import { startVersionWatcher, notifyNewVersionAvailable } from '../modules/versioncheck';
import { Container } from '@material-ui/core';

class App extends Component {
    constructor(props) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
        this.checkTokenValidity = this.checkTokenValidity.bind(this);
    }

    componentDidMount() {
        if (!this.props.authenticated && !this.props.loginInProgress) this.props.CheckAuthentication();

        this.checkTokenValidity();
        // Ongoing (not just at-load) frontend version watch, see modules/versioncheck.js
        startVersionWatcher();
    }

    checkTokenValidity() {
        var _this = this;
        setTimeout(() => {
            if (
                sessionStorage.getItem('accessTokenValidUntil') != null &&
                sessionStorage.getItem('refreshToken') != null
            ) {
                var expires = moment.unix(sessionStorage.getItem('accessTokenValidUntil'));
                var diff = expires.diff(moment(), 'minutes');
                if (diff < 5) {
                    _this.props.RefreshToken();
                }
            }
            _this.checkTokenValidity();
        }, 1000 * 30);
    }

    onSubmit(user, pass, fingerprint) {
        this.props.doLogin(user, pass, fingerprint);
    }

    componentDidUpdate() {
        if (!this.props.authenticated && !this.props.logoffInProgress) {
            if (this.props.history.location != null) {
                if (this.props.history.location.pathname === '/logout') {
                    this.props.history.replace('/');
                }
            }
        }
    }

    render() {
        const jwtPresent = sessionStorage.getItem('refreshToken') != null;
        const showLoginDialog = this.props.loginInProgress || (!jwtPresent && !this.props.authenticated);
        const showLoading =
            this.props.logoffInProgress || (jwtPresent && !this.props.loginInProgress && !this.props.authenticated);

        return (
            <>
                {/* Always mounted, independent of auth/loading state, so toast calls that happen
                    before login (e.g. notifyNewVersionAvailable on the login screen) render immediately
                    instead of queuing and bursting all at once when this would otherwise first mount. */}
                <GlobalNotifications />
                <CacheBuster>
                    {({ loading, isLatestVersion }) => {
                        if (loading) return null;
                        if (!loading && !isLatestVersion) {
                            // Notify + grace-period reload instead of an immediate silent reload,
                            // consistent with the ongoing checks in modules/versioncheck.js.
                            notifyNewVersionAvailable();
                        }
                        if (this.props.newPasswordRequired)
                            return (
                                <ThemeProvider theme={themeMui5}>
                                    <MuiThemeProvider theme={theme}>
                                        <Container disableGutters={true} maxWidth={false}>
                                            <ChangePassword
                                                passwordChangeInProgress={this.props.passwordChangeInProgress}
                                                forcedChangePassword={this.props.doForcedPasswordChange}
                                                passwordChangeFailed={this.props.passwordChangeFailed}
                                                username={this.props.newPasswordRequiredFor}
                                            />
                                        </Container>
                                    </MuiThemeProvider>
                                </ThemeProvider>
                            );
                        if (showLoginDialog)
                            return (
                                <ThemeProvider theme={themeMui5}>
                                    <MuiThemeProvider theme={theme}>
                                        <Container disableGutters={true} maxWidth={false}>
                                            <Login
                                                show={true}
                                                onSubmit={this.onSubmit}
                                                loginFailed={this.props.loginFailed}
                                                loginRateLimited={this.props.loginRateLimited}
                                                loginInProgress={this.props.loginInProgress}
                                            />
                                        </Container>
                                    </MuiThemeProvider>
                                </ThemeProvider>
                            );
                        if (showLoading) {
                            return <div></div>;
                        }
                        return (
                            <ThemeProvider theme={themeMui5}>
                                <MuiThemeProvider theme={theme}>
                                    <Container disableGutters={true} maxWidth={false}>
                                        <Main user={this.props.userProfile} history={this.props.history} />
                                    </Container>
                                </MuiThemeProvider>
                            </ThemeProvider>
                        );
                    }}
                </CacheBuster>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    authenticated: state.authentication.authenticated,
    userProfile: state.authentication.userProfile,
    loginFailed: state.authentication.loginFailed,
    loginRateLimited: state.authentication.loginRateLimited,
    loginInProgress: state.authentication.loginInProgress,
    logoffInProgress: state.authentication.logoffInProgress,
    newPasswordRequired: state.authentication.newPasswordRequired,
    passwordChangeFailed: state.authentication.passwordChangeFailed,
    passwordChangeInProgress: state.authentication.passwordChangeInProgress,
    newPasswordRequiredFor: state.authentication.newPasswordRequiredFor,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ ...authActions, ...orderActions }, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
